import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";

export const useDostepneStatusyProjekt = (rejestrId, enabled = true) => {
    return useQuery({
        queryKey: [`dostepne_statusy_projekt`, rejestrId],
        queryFn: () => getData(`/oper/rejestr/proces/dostepne-statusy/${rejestrId}`),
        enabled: enabled && !!rejestrId
    })
}
